
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { DocumentSubmission } from '@/hooks/useDocumentSubmissions';
import { DocumentTabs } from './DocumentTabs';

interface DocumentMainContentProps {
  document: DocumentSubmission;
  documentUrl: string | null;
  isLoadingPreview: boolean;
  onDownload: () => void;
}

export function DocumentMainContent({
  document,
  documentUrl,
  isLoadingPreview,
  onDownload
}: DocumentMainContentProps) {
  const renderStatusBadge = (status: string) => {
    switch (status) {
      case 'pending':
        return <Badge className="bg-yellow-50 text-yellow-700 border-yellow-200">Pending Review</Badge>;
      case 'approved':
        return <Badge className="bg-green-50 text-green-700 border-green-200">Approved</Badge>;
      case 'rejected':
        return <Badge className="bg-red-50 text-red-700 border-red-200">Rejected</Badge>;
      case 'review':
        return <Badge className="bg-blue-50 text-blue-700 border-blue-200">In Review</Badge>;
      default:
        return <Badge>{status}</Badge>;
    }
  };

  return (
    <Card>
      <CardHeader className="pb-3">
        <div className="flex items-start justify-between">
          <div>
            <CardTitle className="text-xl">{document.title}</CardTitle>
            <CardDescription>{document.description}</CardDescription>
          </div>
          {renderStatusBadge(document.status)}
        </div>
      </CardHeader>
      <CardContent className="pb-6">
        <DocumentTabs
          documentId={document.id}
          title={document.title}
          isLoadingPreview={isLoadingPreview}
          documentUrl={documentUrl}
          onDownload={onDownload}
        />
      </CardContent>
    </Card>
  );
}
